import {useClinicStore} from "@/stores/ClinicData";

type ServiceLike = {
  name: string;
  cost?: string | number;
  checked?: boolean;
};

export function getObjService(servise: ServiceLike): {
  name: string;
  cost: string;
  checked: boolean;
} {
  function splitLastOccurrence(str: string, substring: string): string[] {
    const lastIndex = str.lastIndexOf(substring);
    if (lastIndex == -1) {
      return [str, "0"];
    }
    return [str.slice(0, lastIndex), str.slice(lastIndex + 1)];
  }
  let serviceSplit = splitLastOccurrence(servise.name, ", ");
  if (serviceSplit.length == 1) {
    serviceSplit = splitLastOccurrence(servise.name, " - ");
  }
  if (serviceSplit.length == 3) {
    serviceSplit[1] = serviceSplit[2];
    serviceSplit.pop();
  }
  let cost: string | number = serviceSplit[1] ? serviceSplit[1] : "0";
  if (cost == "0") {
    cost = servise.cost ? servise.cost : "0";
  }
  cost = String(cost);
  let prefix;
  if (cost.replaceAll(" ", "").slice(0, 2).toLowerCase() == "от") {
    prefix = "от";
  }
  cost = cost.replace(/\s/g, "");
  cost = String(cost.match(/\d+/g));
  if (cost.length > 4) {
    cost = cost.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  if (prefix != undefined) {
    cost = prefix + " " + cost;
  }
  const clinicStore = useClinicStore();
  let symbol = clinicStore.getClinic?.currency?.symbol;
  cost += symbol ? " " + symbol : " ₽";
  cost = cost.replace(/ /g, "\u00a0");
  let name = serviceSplit[0];
  const checked = Boolean(servise.checked);
  return {name, cost: String(cost), checked};
}

export function addNull(num: string | number): string {
  if (typeof num == "number") {
    num = String(num);
  }
  if (num.length == 1) {
    return "0" + num;
  } else {
    return num;
  }
}
